import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { getNumberOfAddressesAfterRemovingUserRestaurant as getNumberOfAddressesAfterRemovingUserRestaurantQuery } from "@/graphql/queries";

const client = generateClient();

export const numberOfAddressesAfterRemovingUserRestaurantState = create<
  State<number>
>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getNumberOfAddressesAfterRemovingUserRestaurantIsloading = () =>
  numberOfAddressesAfterRemovingUserRestaurantState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getNumberOfAddressesAfterRemovingUserRestaurantIsError = (
  error: Error,
) =>
  numberOfAddressesAfterRemovingUserRestaurantState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getNumberOfAddressesAfterRemovingUserRestaurantIsSuccess = (
  addresses: number,
) =>
  numberOfAddressesAfterRemovingUserRestaurantState.setState(() => ({
    data: addresses,
    isLoading: false,
    error: null,
  }));

export const resetNumberOfAddressesAfterRemovingUserRestaurantState = () =>
  numberOfAddressesAfterRemovingUserRestaurantState.setState(() =>
    numberOfAddressesAfterRemovingUserRestaurantState.getInitialState(),
  );

export const getNumberOfAddressesAfterRemovingUserRestaurant = async (
  restaurantId: string,
) => {
  getNumberOfAddressesAfterRemovingUserRestaurantIsloading();

  try {
    const { data } = await client.graphql({
      query: getNumberOfAddressesAfterRemovingUserRestaurantQuery,
      variables: {
        restaurantIds: [restaurantId],
      },
    });

    getNumberOfAddressesAfterRemovingUserRestaurantIsSuccess(
      data.getNumberOfAddressesAfterRemovingUserRestaurant,
    );
  } catch (e) {
    const errorMessage =
      e instanceof Error
        ? e.message
        : "failed to query getNumberOfAddressesAfterRemovingUserRestaurant";
    getNumberOfAddressesAfterRemovingUserRestaurantIsError(Error(errorMessage));
  }
};
